module.exports = __webpack_public_path__ + "img/file_jpg.8fe13c0e.svg";